import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/miter-icon.tsx
const MiterIcon = (props) => /* @__PURE__ */ jsxs("svg", {
	width: "24",
	height: "24",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.5 10.5C1.61884 10.4324 1.45723 10.0736 1.5757 10.1418L6.89187 13.2025C7.0097 13.2703 7.08219 13.395 7.08219 13.5299V19.6209C7.08219 19.7563 7.00909 19.8814 6.89045 19.949C6.77181 20.0167 6.6257 20.0165 6.50721 19.9486L1.19103 16.9032C1.0728 16.8354 1 16.7105 1 16.5754V10.4692C1 10.3336 1.38116 10.5676 1.5 10.5ZM1.76602 11.128V16.357L6.31617 18.9637V13.7476L1.76602 11.128Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M6.69928 19.6211L12.0001 16.5756V10.4694L6.69928 13.5301V19.6211Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.1907 10.1407C12.3097 10.2082 12.3831 10.3335 12.3831 10.4692V16.5754C12.3831 16.7103 12.3104 16.8351 12.1924 16.9029L6.8916 19.9484C6.77312 20.0165 6.6269 20.0168 6.50815 19.9492C6.38939 19.8816 6.3162 19.7564 6.3162 19.6209V13.5299C6.3162 13.3952 6.3885 13.2706 6.5061 13.2027L11.8069 10.1421C11.9254 10.0737 12.0718 10.0731 12.1907 10.1407ZM7.08221 13.7473V18.9627L11.617 16.3574V11.129L7.08221 13.7473Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.8088 10.141C11.9277 10.0732 12.0742 10.0735 12.1928 10.1418L17.509 13.2025C17.6268 13.2703 17.6993 13.395 17.6993 13.5299V19.6209C17.6993 19.7564 17.6261 19.8816 17.5073 19.9492C17.3886 20.0168 17.2423 20.0165 17.1239 19.9484L11.823 16.9029C11.7053 16.8353 11.6328 16.7109 11.6324 16.5763L11.6171 10.4701C11.6168 10.3344 11.6899 10.2088 11.8088 10.141ZM12.3848 11.129L12.3979 16.357L16.9333 18.9627V13.7476L12.3848 11.129Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M22.6172 16.5756V10.4694L17.3011 13.5301V19.6211L22.6172 16.5756Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.8079 10.1411C22.9267 10.2087 23 10.334 23 10.4695V16.5757C23 16.7109 22.9272 16.8358 22.809 16.9035L17.4928 19.949C17.3743 20.0169 17.2282 20.017 17.1096 19.9494C16.9909 19.8818 16.9178 19.7566 16.9178 19.6212V13.5302C16.9178 13.3953 16.9903 13.2707 17.1081 13.2028L22.4243 10.1422C22.5428 10.074 22.6891 10.0736 22.8079 10.1411ZM17.6838 13.748V18.964L22.234 16.3574V11.1283L17.6838 13.748Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.8078 4.05114C11.9267 3.98295 12.0734 3.98295 12.1922 4.05114L22.8092 10.1422C22.9272 10.2099 22.9999 10.3346 23 10.4695C23.0001 10.6045 22.9276 10.7293 22.8097 10.7972L17.4935 13.8578C17.3743 13.9265 17.2269 13.9264 17.1077 13.8576L12 10.9084L6.89229 13.8576C6.77312 13.9264 6.62574 13.9265 6.50649 13.8578L1.19032 10.7972C1.07239 10.7293 0.999896 10.6041 1 10.4692C1.0001 10.3342 1.0728 10.2099 1.19083 10.1422L11.8078 4.05114ZM2.14531 10.4704L6.6989 13.092L11.8069 10.1421C11.9263 10.0732 12.0735 10.0729 12.1928 10.1418L17.3011 13.092L21.8547 10.4704L12 4.81671L2.14531 10.4704Z",
			fill: "currentColor"
		})
	]
});
//#endregion
export { MiterIcon };

//# sourceMappingURL=miter-icon.js.map